import updateTherapist from './UpdateTherapist'
export default updateTherapist
